import DescriptionTwoToneIcon from "@material-ui/icons/DescriptionTwoTone";
import HomeWorkTwoToneIcon from "@material-ui/icons/HomeWorkTwoTone";
import PeopleOutlineTwoToneIcon from "@material-ui/icons/PeopleOutlineTwoTone";
import ListAltTwoToneIcon from "@material-ui/icons/ListAltTwoTone";
import PeopleAltTwoToneIcon from "@material-ui/icons/PeopleAltTwoTone";
import MonetizationOnTwoToneIcon from "@material-ui/icons/MonetizationOnTwoTone";
import SettingsEthernetTwoToneIcon from "@material-ui/icons/SettingsEthernetTwoTone";

export default function navConfig() {
  return [
    {
      subheader: "Presupuestos",
      items: [
        {
          title: "Nuevo Presupuesto",
          icon: DescriptionTwoToneIcon,
          href: "/nuevo-presupuesto",
        },
        {
          title: "Ver Presupuestos",
          icon: ListAltTwoToneIcon,
          href: "/lista-presupuesto",
        },
      ],
    },
    {
      subheader: "Clientes",
      items: [
        {
          title: "Clientes",
          icon: PeopleOutlineTwoToneIcon,
          href: "/lista-clientes",
        },
      ],
    },
    {
      subheader: "Cortinas",
      items: [
        {
          title: "Carateristicas",
          icon: SettingsEthernetTwoToneIcon,
          href: "/cortinas-caracteristicas",
        },
      ],
    },
    {
      subheader: "Franquicias",
      items: [
        {
          title: "Franquicias",
          icon: HomeWorkTwoToneIcon,
          href: "/lista-franquicias",
        },
        {
          title: "Cotizaciones",
          icon: MonetizationOnTwoToneIcon,
          href: "/lista-cotizaciones",
        },
      ],
    },
    {
      subheader: "Usuarios",
      items: [
        {
          title: "Mis usuarios",
          icon: PeopleAltTwoToneIcon,
          href: "/lista-usuarios",
        },
      ],
    },
  ];
}
